import { ColumnTable, Button } from '@octano/global-ui';
import BadgeState from '../parts/BadgeState';
import { moneyFormatter } from '../../../../../utils/currency';
import { PaymentInfo } from '../../../types';

type Texts = {
  noResults: string;
  headers: {
    concept: string;
    amount: string;
    paymentDate: string;
    status: string;
    action: string;
  };
  values: {
    concept: string;
    payment: { pending: string; paid: string };
    actions: { send: string; update: string; paid: string };
  };
};

export function useColumns(
  texts: Texts,
  options: {
    provider: string | null;
    loading: boolean;
    readOnly?: boolean;
    onSend: () => void;
    onRefresh: () => void;
  },
): Array<ColumnTable<PaymentInfo>> {
  return [
    {
      columnName: 'concept',
      thClassName: 'text-center',
      tdClassName: 'text-center',
      headerText: texts.headers.concept,
      width: '15%',
      cellFormat: () => <div>{texts.values.concept}</div>,
    },
    {
      columnName: 'amount',
      thClassName: 'text-center',
      tdClassName: 'text-center',
      headerText: texts.headers.amount,
      cellFormat: ({ row }) => <div>{moneyFormatter().format(row.amount)}</div>,
    },
    {
      columnName: 'paymentDate',
      thClassName: 'text-center',
      tdClassName: 'text-center',
      headerText: texts.headers.paymentDate,
      cellFormat: ({ row }) =>
        row.paymentDate ? <div>{row.paymentDate}</div> : null,
    },
    {
      columnName: 'status',
      thClassName: 'text-center',
      tdClassName: 'text-center',
      headerText: texts.headers.status,
      cellFormat: ({ row }) =>
        row.status === 'success' ? (
          <BadgeState status="approved" text={texts.values.payment.paid} />
        ) : (
          <BadgeState status="pending" text={texts.values.payment.pending} />
        ),
    },
    {
      columnName: 'action',
      thClassName: 'text-center',
      tdClassName: 'text-center',
      headerText: texts.headers.action,
      width: '15%',
      cellFormat: ({ row }) => {
        if (row.status === 'success') {
          return (
            <Button
              disabled
              size="sm"
              fullwidth
              text={texts.values.actions.paid}
            />
          );
        }
        if (row.status === 'processing') {
          return (
            <Button
              size="sm"
              fullwidth
              disabled={options.readOnly || options.loading}
              loading={options.loading}
              text={texts.values.actions.update}
              onClick={options.onRefresh}
            />
          );
        }
        return (
          <Button
            size="sm"
            fullwidth
            disabled={options.readOnly || !options.provider || options.loading}
            loading={options.loading}
            text={texts.values.actions.send}
            onClick={options.onSend}
          />
        );
      },
    },
  ];
}
